"use strict";
// @flow
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANGUAGE_CHANGED = exports.I18NEXT_INITIALIZED = void 0;
/**
 * The type of (redux) action which signals that i18next has been initialized.
 */
exports.I18NEXT_INITIALIZED = 'I18NEXT_INITIALIZED';
/**
 * The type of (redux) action which signals that language has been changed.
 */
exports.LANGUAGE_CHANGED = 'LANGUAGE_CHANGED';
